import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FiPlus, FiUsers } from "react-icons/fi";

import { ItemPagination } from "../../components/ItemPagination";

import { api } from "../../services/api";
import { AuthContext, useAuth } from "../../contexts/AuthContext";
import { PageTitle } from "../../components/PageTitle";
import { EmptyState } from "../../components/EmptyState";
import { CanAccess } from "../../components/CanAccess";

interface Zone {
  id: string;
  name: string;
  status: string;
  color?: string;
}

export function Zones() {
  const { user } = useContext(AuthContext);
  const { hasPermission } = useAuth();
  const [zones, setZones] = useState<Zone[]>([]);
  const [changeStatus, setChangeStatus] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    api
      .get("/zones")
      .then(response => {
        setZones(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        navigate("/signin");
      });
  }, [changeStatus]);

  async function handleChangeStatus(id: string, newStatus: string) {
    api.patch(`zones/status/${id}/${newStatus === "A" ? "I" : "A"}`);
    setTimeout(() => {
      setChangeStatus(changeStatus + 1);
    }, 1000);
  }

  return (
    <div className="container mx-auto">
      <PageTitle title="Zonas" backButton backPath="/home" />
      <div className="flex items-start justify-between mb-6">
        <div className="flex gap-3">
          <CanAccess permission="zones:create" allowAdmin>
            <Link
              to="/zones/new"
              className="group bg-[#0085BD] text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:bg-[#006a96] transition-all duration-200 hover:shadow-xl"
              title="Nova Zona"
            >
              <FiPlus size={24} className="transition-transform duration-200 group-hover:rotate-90" />
            </Link>
          </CanAccess>
          <CanAccess permission="zones:update" allowAdmin>
            <Link
              to="/zones/assign-costumers"
              className="group bg-[#0085BD] text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:bg-[#006a96] transition-all duration-200 hover:shadow-xl"
              title="Vincular Clientes às Zonas"
            >
              <FiUsers size={24} className="transition-transform duration-200 group-hover:scale-110" />
            </Link>
          </CanAccess>
        </div>
      </div>
      <div className="space-y-2">
        {loading && (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0085BD]" />
          </div>
        )}
        {!loading &&
          zones.length > 0 &&
          zones.map(({ id, name, status, color }: Zone) => (
            <ItemPagination
              key={id}
              title={name}
              titleColor={color}
              id={id}
              status={status}
              hasDelete
              canEdit={hasPermission("zones:update")}
              canDelete={hasPermission("zones:delete")}
              handleChangeStatus={() => handleChangeStatus(id, status)}
            />
          ))}
        {!loading && zones.length === 0 && (
          <div className="col-span-full">
            <EmptyState type="zones" />
          </div>
        )}
      </div>
    </div>
  );
}
